import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import { observer } from 'mobx-react';
import queryString from 'query-string';

import { Form, Field } from 'lib/form/form';
import FormView from 'lib/form/form-view';
import withDialog from 'lib/alerts/with-dialog';
import { ValueFieldData, RequiredValidator } from 'lib/form/value-field-data';

import withStackViewForm from 'four-nets/ui/with-stack-view-form';
import SubmitButtonView from 'four-nets/ui/submit-button/submit-button-view';
import FieldWithLabelView from 'four-nets/ui/form/field-with-label-view';
import TextAreaView from 'four-nets/ui-v2/form/text-area/text-area';
import Styled from 'styled';

import defaultStyles from './create-complaint-view.scss';

export class ComplaintForm extends Form {
    constructor(options) {
        super({
            ...options,
            field: {
                comment: new Field({
                    data: new ValueFieldData(),
                    validators: [new RequiredValidator()],
                }),
            },
        });
    }
}

@withStackViewForm({ hideAction: true, title: <FormattedMessage id='BAZAAR_COMPLAIN' /> })
@withDialog
@Styled(defaultStyles)
@observer
class CreateComplaintView extends React.Component {
    submit = () => {
        this.props.submit().then(() => {
            this.props.history.push({
                pathname: this.props.location.pathname,
                search: `?${queryString.stringify({
                    ...queryString.parse(this.props.location.search),
                })}`,
            });
        });
    };

    render() {
        const { form, styles } = this.props;
        const { valid, dirty } = form;
        return (
            <div className={styles.wrapper}>
                <FormView form={form} submitOnEnter={false} submit={this.submit}>
                    <FieldWithLabelView
                        key='comment'
                        id='comment'
                        field={<TextAreaView field={form.field.get('comment')} type='text' emojify={false} />}
                        label={<FormattedMessage id='ADD_DESCRIPTION' />}
                    />
                    <div className={styles.submitButtonWrapper}>
                        <SubmitButtonView disabled={!(valid && dirty)} onClick={this.submit}>
                            <FormattedMessage id='BUTTON_LABEL_SEND' />
                        </SubmitButtonView>
                    </div>
                </FormView>
            </div>
        );
    }
}

export default withRouter(CreateComplaintView);
